/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddConsultantNotesCommandResult } from '../models/add-consultant-notes-command-result';
import { apiProjectDailyExpectedTasksCreateProjectDailyTaskPost } from '../fn/project-daily-reports/api-project-daily-expected-tasks-create-project-daily-task-post';
import { ApiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Params } from '../fn/project-daily-reports/api-project-daily-expected-tasks-create-project-daily-task-post';
import { apiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Plain } from '../fn/project-daily-reports/api-project-daily-expected-tasks-create-project-daily-task-post-plain';
import { ApiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Plain$Params } from '../fn/project-daily-reports/api-project-daily-expected-tasks-create-project-daily-task-post-plain';
import { apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete } from '../fn/project-daily-reports/api-project-daily-expected-tasks-delete-project-daily-task-delete';
import { ApiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Params } from '../fn/project-daily-reports/api-project-daily-expected-tasks-delete-project-daily-task-delete';
import { apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Plain } from '../fn/project-daily-reports/api-project-daily-expected-tasks-delete-project-daily-task-delete-plain';
import { ApiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Plain$Params } from '../fn/project-daily-reports/api-project-daily-expected-tasks-delete-project-daily-task-delete-plain';
import { apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost } from '../fn/project-daily-reports/api-project-daily-expected-tasks-get-project-daily-expected-tasks-post';
import { ApiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Params } from '../fn/project-daily-reports/api-project-daily-expected-tasks-get-project-daily-expected-tasks-post';
import { apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain } from '../fn/project-daily-reports/api-project-daily-expected-tasks-get-project-daily-expected-tasks-post-plain';
import { ApiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain$Params } from '../fn/project-daily-reports/api-project-daily-expected-tasks-get-project-daily-expected-tasks-post-plain';
import { apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch } from '../fn/project-daily-reports/api-project-daily-expected-tasks-update-project-daily-task-patch';
import { ApiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Params } from '../fn/project-daily-reports/api-project-daily-expected-tasks-update-project-daily-task-patch';
import { apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Plain } from '../fn/project-daily-reports/api-project-daily-expected-tasks-update-project-daily-task-patch-plain';
import { ApiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Plain$Params } from '../fn/project-daily-reports/api-project-daily-expected-tasks-update-project-daily-task-patch-plain';
import { apiProjectDailyTaskReportsAddConsultantNotesPatch } from '../fn/project-daily-reports/api-project-daily-task-reports-add-consultant-notes-patch';
import { ApiProjectDailyTaskReportsAddConsultantNotesPatch$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-add-consultant-notes-patch';
import { apiProjectDailyTaskReportsAddConsultantNotesPatch$Plain } from '../fn/project-daily-reports/api-project-daily-task-reports-add-consultant-notes-patch-plain';
import { ApiProjectDailyTaskReportsAddConsultantNotesPatch$Plain$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-add-consultant-notes-patch-plain';
import { apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost } from '../fn/project-daily-reports/api-project-daily-task-reports-create-project-daily-task-report-post';
import { ApiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-create-project-daily-task-report-post';
import { apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Plain } from '../fn/project-daily-reports/api-project-daily-task-reports-create-project-daily-task-report-post-plain';
import { ApiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Plain$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-create-project-daily-task-report-post-plain';
import { apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete } from '../fn/project-daily-reports/api-project-daily-task-reports-delete-project-daily-task-report-delete';
import { ApiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-delete-project-daily-task-report-delete';
import { apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain } from '../fn/project-daily-reports/api-project-daily-task-reports-delete-project-daily-task-report-delete-plain';
import { ApiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-delete-project-daily-task-report-delete-plain';
import { apiProjectDailyTaskReportsGetProjectDailyTaskReportGet } from '../fn/project-daily-reports/api-project-daily-task-reports-get-project-daily-task-report-get';
import { ApiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-get-project-daily-task-report-get';
import { apiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Plain } from '../fn/project-daily-reports/api-project-daily-task-reports-get-project-daily-task-report-get-plain';
import { ApiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Plain$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-get-project-daily-task-report-get-plain';
import { apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost } from '../fn/project-daily-reports/api-project-daily-task-reports-get-project-daily-task-reports-post';
import { ApiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-get-project-daily-task-reports-post';
import { apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain } from '../fn/project-daily-reports/api-project-daily-task-reports-get-project-daily-task-reports-post-plain';
import { ApiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-get-project-daily-task-reports-post-plain';
import { apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet } from '../fn/project-daily-reports/api-project-daily-task-reports-get-project-items-for-daily-task-report-get';
import { ApiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-get-project-items-for-daily-task-report-get';
import { apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Plain } from '../fn/project-daily-reports/api-project-daily-task-reports-get-project-items-for-daily-task-report-get-plain';
import { ApiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Plain$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-get-project-items-for-daily-task-report-get-plain';
import { apiProjectDailyTaskReportsGetReportHeaderGet } from '../fn/project-daily-reports/api-project-daily-task-reports-get-report-header-get';
import { ApiProjectDailyTaskReportsGetReportHeaderGet$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-get-report-header-get';
import { apiProjectDailyTaskReportsGetReportHeaderGet$Plain } from '../fn/project-daily-reports/api-project-daily-task-reports-get-report-header-get-plain';
import { ApiProjectDailyTaskReportsGetReportHeaderGet$Plain$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-get-report-header-get-plain';
import { apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch } from '../fn/project-daily-reports/api-project-daily-task-reports-update-project-daily-task-report-by-consultive-patch';
import { ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-update-project-daily-task-report-by-consultive-patch';
import { apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Plain } from '../fn/project-daily-reports/api-project-daily-task-reports-update-project-daily-task-report-by-consultive-patch-plain';
import { ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Plain$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-update-project-daily-task-report-by-consultive-patch-plain';
import { apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch } from '../fn/project-daily-reports/api-project-daily-task-reports-update-project-daily-task-report-by-contractor-patch';
import { ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-update-project-daily-task-report-by-contractor-patch';
import { apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Plain } from '../fn/project-daily-reports/api-project-daily-task-reports-update-project-daily-task-report-by-contractor-patch-plain';
import { ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Plain$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-update-project-daily-task-report-by-contractor-patch-plain';
import { apiProjectDailyTaskReportsUploadFileForReportPost } from '../fn/project-daily-reports/api-project-daily-task-reports-upload-file-for-report-post';
import { ApiProjectDailyTaskReportsUploadFileForReportPost$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-upload-file-for-report-post';
import { apiProjectDailyTaskReportsUploadFileForReportPost$Plain } from '../fn/project-daily-reports/api-project-daily-task-reports-upload-file-for-report-post-plain';
import { ApiProjectDailyTaskReportsUploadFileForReportPost$Plain$Params } from '../fn/project-daily-reports/api-project-daily-task-reports-upload-file-for-report-post-plain';
import { apiProjectDailyTasksCreateProjectDailyTaskPost } from '../fn/project-daily-reports/api-project-daily-tasks-create-project-daily-task-post';
import { ApiProjectDailyTasksCreateProjectDailyTaskPost$Params } from '../fn/project-daily-reports/api-project-daily-tasks-create-project-daily-task-post';
import { apiProjectDailyTasksCreateProjectDailyTaskPost$Plain } from '../fn/project-daily-reports/api-project-daily-tasks-create-project-daily-task-post-plain';
import { ApiProjectDailyTasksCreateProjectDailyTaskPost$Plain$Params } from '../fn/project-daily-reports/api-project-daily-tasks-create-project-daily-task-post-plain';
import { apiProjectDailyTasksDeleteProjectDailyTaskDelete } from '../fn/project-daily-reports/api-project-daily-tasks-delete-project-daily-task-delete';
import { ApiProjectDailyTasksDeleteProjectDailyTaskDelete$Params } from '../fn/project-daily-reports/api-project-daily-tasks-delete-project-daily-task-delete';
import { apiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain } from '../fn/project-daily-reports/api-project-daily-tasks-delete-project-daily-task-delete-plain';
import { ApiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain$Params } from '../fn/project-daily-reports/api-project-daily-tasks-delete-project-daily-task-delete-plain';
import { apiProjectDailyTasksGetProjectDailyTasksPost } from '../fn/project-daily-reports/api-project-daily-tasks-get-project-daily-tasks-post';
import { ApiProjectDailyTasksGetProjectDailyTasksPost$Params } from '../fn/project-daily-reports/api-project-daily-tasks-get-project-daily-tasks-post';
import { apiProjectDailyTasksGetProjectDailyTasksPost$Plain } from '../fn/project-daily-reports/api-project-daily-tasks-get-project-daily-tasks-post-plain';
import { ApiProjectDailyTasksGetProjectDailyTasksPost$Plain$Params } from '../fn/project-daily-reports/api-project-daily-tasks-get-project-daily-tasks-post-plain';
import { apiProjectDailyTasksUpdateProjectDailyTaskPatch } from '../fn/project-daily-reports/api-project-daily-tasks-update-project-daily-task-patch';
import { ApiProjectDailyTasksUpdateProjectDailyTaskPatch$Params } from '../fn/project-daily-reports/api-project-daily-tasks-update-project-daily-task-patch';
import { apiProjectDailyTasksUpdateProjectDailyTaskPatch$Plain } from '../fn/project-daily-reports/api-project-daily-tasks-update-project-daily-task-patch-plain';
import { ApiProjectDailyTasksUpdateProjectDailyTaskPatch$Plain$Params } from '../fn/project-daily-reports/api-project-daily-tasks-update-project-daily-task-patch-plain';
import { CreateProjectDailyTaskCommandResult } from '../models/create-project-daily-task-command-result';
import { CreateProjectDailyTaskReportCommandResult } from '../models/create-project-daily-task-report-command-result';
import { DeleteProjectDailyTaskCommandResult } from '../models/delete-project-daily-task-command-result';
import { DeleteProjectDailyTaskReportCommandResult } from '../models/delete-project-daily-task-report-command-result';
import { GetProjectDailyExpectedTasksQueryResult } from '../models/get-project-daily-expected-tasks-query-result';
import { GetProjectDailyTaskReportQueryResult } from '../models/get-project-daily-task-report-query-result';
import { GetProjectDailyTaskReportsQueryResult } from '../models/get-project-daily-task-reports-query-result';
import { GetProjectDailyTasksQueryResult } from '../models/get-project-daily-tasks-query-result';
import { GetProjectItemsForDailyTaskReportQueryResult } from '../models/get-project-items-for-daily-task-report-query-result';
import { GetReportHeaderQueryResult } from '../models/get-report-header-query-result';
import { UpdateProjectDailyTaskCommandResult } from '../models/update-project-daily-task-command-result';
import { UpdateProjectDailyTaskReportByConsultiveCommandResult } from '../models/update-project-daily-task-report-by-consultive-command-result';
import { UpdateProjectDailyTaskReportByContractorCommandResult } from '../models/update-project-daily-task-report-by-contractor-command-result';
import { UploadFileForReportCommandResult } from '../models/upload-file-for-report-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectDailyReportsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectDailyTasksGetProjectDailyTasksPost()` */
  static readonly ApiProjectDailyTasksGetProjectDailyTasksPostPath = '/api/ProjectDailyTasks/GetProjectDailyTasks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTasksGetProjectDailyTasksPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksGetProjectDailyTasksPost$Plain$Response(params?: ApiProjectDailyTasksGetProjectDailyTasksPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectDailyTasksQueryResult>> {
    return apiProjectDailyTasksGetProjectDailyTasksPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTasksGetProjectDailyTasksPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksGetProjectDailyTasksPost$Plain(params?: ApiProjectDailyTasksGetProjectDailyTasksPost$Plain$Params, context?: HttpContext): Observable<GetProjectDailyTasksQueryResult> {
    return this.apiProjectDailyTasksGetProjectDailyTasksPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectDailyTasksQueryResult>): GetProjectDailyTasksQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTasksGetProjectDailyTasksPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksGetProjectDailyTasksPost$Response(params?: ApiProjectDailyTasksGetProjectDailyTasksPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectDailyTasksQueryResult>> {
    return apiProjectDailyTasksGetProjectDailyTasksPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTasksGetProjectDailyTasksPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksGetProjectDailyTasksPost(params?: ApiProjectDailyTasksGetProjectDailyTasksPost$Params, context?: HttpContext): Observable<GetProjectDailyTasksQueryResult> {
    return this.apiProjectDailyTasksGetProjectDailyTasksPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectDailyTasksQueryResult>): GetProjectDailyTasksQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyTasksCreateProjectDailyTaskPost()` */
  static readonly ApiProjectDailyTasksCreateProjectDailyTaskPostPath = '/api/ProjectDailyTasks/CreateProjectDailyTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTasksCreateProjectDailyTaskPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksCreateProjectDailyTaskPost$Plain$Response(params?: ApiProjectDailyTasksCreateProjectDailyTaskPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectDailyTaskCommandResult>> {
    return apiProjectDailyTasksCreateProjectDailyTaskPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTasksCreateProjectDailyTaskPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksCreateProjectDailyTaskPost$Plain(params?: ApiProjectDailyTasksCreateProjectDailyTaskPost$Plain$Params, context?: HttpContext): Observable<CreateProjectDailyTaskCommandResult> {
    return this.apiProjectDailyTasksCreateProjectDailyTaskPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectDailyTaskCommandResult>): CreateProjectDailyTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTasksCreateProjectDailyTaskPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksCreateProjectDailyTaskPost$Response(params?: ApiProjectDailyTasksCreateProjectDailyTaskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectDailyTaskCommandResult>> {
    return apiProjectDailyTasksCreateProjectDailyTaskPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTasksCreateProjectDailyTaskPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksCreateProjectDailyTaskPost(params?: ApiProjectDailyTasksCreateProjectDailyTaskPost$Params, context?: HttpContext): Observable<CreateProjectDailyTaskCommandResult> {
    return this.apiProjectDailyTasksCreateProjectDailyTaskPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectDailyTaskCommandResult>): CreateProjectDailyTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyTasksUpdateProjectDailyTaskPatch()` */
  static readonly ApiProjectDailyTasksUpdateProjectDailyTaskPatchPath = '/api/ProjectDailyTasks/UpdateProjectDailyTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTasksUpdateProjectDailyTaskPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksUpdateProjectDailyTaskPatch$Plain$Response(params?: ApiProjectDailyTasksUpdateProjectDailyTaskPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectDailyTaskCommandResult>> {
    return apiProjectDailyTasksUpdateProjectDailyTaskPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTasksUpdateProjectDailyTaskPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksUpdateProjectDailyTaskPatch$Plain(params?: ApiProjectDailyTasksUpdateProjectDailyTaskPatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectDailyTaskCommandResult> {
    return this.apiProjectDailyTasksUpdateProjectDailyTaskPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectDailyTaskCommandResult>): UpdateProjectDailyTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTasksUpdateProjectDailyTaskPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksUpdateProjectDailyTaskPatch$Response(params?: ApiProjectDailyTasksUpdateProjectDailyTaskPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectDailyTaskCommandResult>> {
    return apiProjectDailyTasksUpdateProjectDailyTaskPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTasksUpdateProjectDailyTaskPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksUpdateProjectDailyTaskPatch(params?: ApiProjectDailyTasksUpdateProjectDailyTaskPatch$Params, context?: HttpContext): Observable<UpdateProjectDailyTaskCommandResult> {
    return this.apiProjectDailyTasksUpdateProjectDailyTaskPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectDailyTaskCommandResult>): UpdateProjectDailyTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyTasksDeleteProjectDailyTaskDelete()` */
  static readonly ApiProjectDailyTasksDeleteProjectDailyTaskDeletePath = '/api/ProjectDailyTasks/DeleteProjectDailyTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain$Response(params?: ApiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectDailyTaskCommandResult>> {
    return apiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain(params?: ApiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectDailyTaskCommandResult> {
    return this.apiProjectDailyTasksDeleteProjectDailyTaskDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectDailyTaskCommandResult>): DeleteProjectDailyTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTasksDeleteProjectDailyTaskDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksDeleteProjectDailyTaskDelete$Response(params?: ApiProjectDailyTasksDeleteProjectDailyTaskDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectDailyTaskCommandResult>> {
    return apiProjectDailyTasksDeleteProjectDailyTaskDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTasksDeleteProjectDailyTaskDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTasksDeleteProjectDailyTaskDelete(params?: ApiProjectDailyTasksDeleteProjectDailyTaskDelete$Params, context?: HttpContext): Observable<DeleteProjectDailyTaskCommandResult> {
    return this.apiProjectDailyTasksDeleteProjectDailyTaskDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectDailyTaskCommandResult>): DeleteProjectDailyTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet()` */
  static readonly ApiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGetPath = '/api/ProjectDailyTaskReports/GetProjectItemsForDailyTaskReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Plain$Response(params?: ApiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemsForDailyTaskReportQueryResult>> {
    return apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Plain(params?: ApiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Plain$Params, context?: HttpContext): Observable<GetProjectItemsForDailyTaskReportQueryResult> {
    return this.apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemsForDailyTaskReportQueryResult>): GetProjectItemsForDailyTaskReportQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Response(params?: ApiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemsForDailyTaskReportQueryResult>> {
    return apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet(params?: ApiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Params, context?: HttpContext): Observable<GetProjectItemsForDailyTaskReportQueryResult> {
    return this.apiProjectDailyTaskReportsGetProjectItemsForDailyTaskReportGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectItemsForDailyTaskReportQueryResult>): GetProjectItemsForDailyTaskReportQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyTaskReportsGetProjectDailyTaskReportGet()` */
  static readonly ApiProjectDailyTaskReportsGetProjectDailyTaskReportGetPath = '/api/ProjectDailyTaskReports/GetProjectDailyTaskReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Plain$Response(params?: ApiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectDailyTaskReportQueryResult>> {
    return apiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Plain(params?: ApiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Plain$Params, context?: HttpContext): Observable<GetProjectDailyTaskReportQueryResult> {
    return this.apiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectDailyTaskReportQueryResult>): GetProjectDailyTaskReportQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsGetProjectDailyTaskReportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Response(params?: ApiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectDailyTaskReportQueryResult>> {
    return apiProjectDailyTaskReportsGetProjectDailyTaskReportGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectDailyTaskReportsGetProjectDailyTaskReportGet(params?: ApiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Params, context?: HttpContext): Observable<GetProjectDailyTaskReportQueryResult> {
    return this.apiProjectDailyTaskReportsGetProjectDailyTaskReportGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectDailyTaskReportQueryResult>): GetProjectDailyTaskReportQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyTaskReportsGetReportHeaderGet()` */
  static readonly ApiProjectDailyTaskReportsGetReportHeaderGetPath = '/api/ProjectDailyTaskReports/GetReportHeader';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsGetReportHeaderGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectDailyTaskReportsGetReportHeaderGet$Plain$Response(params?: ApiProjectDailyTaskReportsGetReportHeaderGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetReportHeaderQueryResult>> {
    return apiProjectDailyTaskReportsGetReportHeaderGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsGetReportHeaderGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectDailyTaskReportsGetReportHeaderGet$Plain(params?: ApiProjectDailyTaskReportsGetReportHeaderGet$Plain$Params, context?: HttpContext): Observable<GetReportHeaderQueryResult> {
    return this.apiProjectDailyTaskReportsGetReportHeaderGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetReportHeaderQueryResult>): GetReportHeaderQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsGetReportHeaderGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectDailyTaskReportsGetReportHeaderGet$Response(params?: ApiProjectDailyTaskReportsGetReportHeaderGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetReportHeaderQueryResult>> {
    return apiProjectDailyTaskReportsGetReportHeaderGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsGetReportHeaderGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectDailyTaskReportsGetReportHeaderGet(params?: ApiProjectDailyTaskReportsGetReportHeaderGet$Params, context?: HttpContext): Observable<GetReportHeaderQueryResult> {
    return this.apiProjectDailyTaskReportsGetReportHeaderGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetReportHeaderQueryResult>): GetReportHeaderQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost()` */
  static readonly ApiProjectDailyTaskReportsGetProjectDailyTaskReportsPostPath = '/api/ProjectDailyTaskReports/GetProjectDailyTaskReports';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain$Response(params?: ApiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectDailyTaskReportsQueryResult>> {
    return apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain(params?: ApiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain$Params, context?: HttpContext): Observable<GetProjectDailyTaskReportsQueryResult> {
    return this.apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectDailyTaskReportsQueryResult>): GetProjectDailyTaskReportsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Response(params?: ApiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectDailyTaskReportsQueryResult>> {
    return apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost(params?: ApiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Params, context?: HttpContext): Observable<GetProjectDailyTaskReportsQueryResult> {
    return this.apiProjectDailyTaskReportsGetProjectDailyTaskReportsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectDailyTaskReportsQueryResult>): GetProjectDailyTaskReportsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyTaskReportsUploadFileForReportPost()` */
  static readonly ApiProjectDailyTaskReportsUploadFileForReportPostPath = '/api/ProjectDailyTaskReports/UploadFileForReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsUploadFileForReportPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectDailyTaskReportsUploadFileForReportPost$Plain$Response(params?: ApiProjectDailyTaskReportsUploadFileForReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UploadFileForReportCommandResult>> {
    return apiProjectDailyTaskReportsUploadFileForReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsUploadFileForReportPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectDailyTaskReportsUploadFileForReportPost$Plain(params?: ApiProjectDailyTaskReportsUploadFileForReportPost$Plain$Params, context?: HttpContext): Observable<UploadFileForReportCommandResult> {
    return this.apiProjectDailyTaskReportsUploadFileForReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UploadFileForReportCommandResult>): UploadFileForReportCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsUploadFileForReportPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectDailyTaskReportsUploadFileForReportPost$Response(params?: ApiProjectDailyTaskReportsUploadFileForReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UploadFileForReportCommandResult>> {
    return apiProjectDailyTaskReportsUploadFileForReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsUploadFileForReportPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectDailyTaskReportsUploadFileForReportPost(params?: ApiProjectDailyTaskReportsUploadFileForReportPost$Params, context?: HttpContext): Observable<UploadFileForReportCommandResult> {
    return this.apiProjectDailyTaskReportsUploadFileForReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UploadFileForReportCommandResult>): UploadFileForReportCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost()` */
  static readonly ApiProjectDailyTaskReportsCreateProjectDailyTaskReportPostPath = '/api/ProjectDailyTaskReports/CreateProjectDailyTaskReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Plain$Response(params?: ApiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectDailyTaskReportCommandResult>> {
    return apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Plain(params?: ApiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Plain$Params, context?: HttpContext): Observable<CreateProjectDailyTaskReportCommandResult> {
    return this.apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectDailyTaskReportCommandResult>): CreateProjectDailyTaskReportCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Response(params?: ApiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectDailyTaskReportCommandResult>> {
    return apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost(params?: ApiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Params, context?: HttpContext): Observable<CreateProjectDailyTaskReportCommandResult> {
    return this.apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectDailyTaskReportCommandResult>): CreateProjectDailyTaskReportCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch()` */
  static readonly ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatchPath = '/api/ProjectDailyTaskReports/UpdateProjectDailyTaskReportByConsultive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Plain$Response(params?: ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectDailyTaskReportByConsultiveCommandResult>> {
    return apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Plain(params?: ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectDailyTaskReportByConsultiveCommandResult> {
    return this.apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectDailyTaskReportByConsultiveCommandResult>): UpdateProjectDailyTaskReportByConsultiveCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Response(params?: ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectDailyTaskReportByConsultiveCommandResult>> {
    return apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch(params?: ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Params, context?: HttpContext): Observable<UpdateProjectDailyTaskReportByConsultiveCommandResult> {
    return this.apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByConsultivePatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectDailyTaskReportByConsultiveCommandResult>): UpdateProjectDailyTaskReportByConsultiveCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyTaskReportsAddConsultantNotesPatch()` */
  static readonly ApiProjectDailyTaskReportsAddConsultantNotesPatchPath = '/api/ProjectDailyTaskReports/AddConsultantNotes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsAddConsultantNotesPatch$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectDailyTaskReportsAddConsultantNotesPatch$Plain$Response(params?: ApiProjectDailyTaskReportsAddConsultantNotesPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddConsultantNotesCommandResult>> {
    return apiProjectDailyTaskReportsAddConsultantNotesPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsAddConsultantNotesPatch$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectDailyTaskReportsAddConsultantNotesPatch$Plain(params?: ApiProjectDailyTaskReportsAddConsultantNotesPatch$Plain$Params, context?: HttpContext): Observable<AddConsultantNotesCommandResult> {
    return this.apiProjectDailyTaskReportsAddConsultantNotesPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddConsultantNotesCommandResult>): AddConsultantNotesCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsAddConsultantNotesPatch()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectDailyTaskReportsAddConsultantNotesPatch$Response(params?: ApiProjectDailyTaskReportsAddConsultantNotesPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<AddConsultantNotesCommandResult>> {
    return apiProjectDailyTaskReportsAddConsultantNotesPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsAddConsultantNotesPatch$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiProjectDailyTaskReportsAddConsultantNotesPatch(params?: ApiProjectDailyTaskReportsAddConsultantNotesPatch$Params, context?: HttpContext): Observable<AddConsultantNotesCommandResult> {
    return this.apiProjectDailyTaskReportsAddConsultantNotesPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddConsultantNotesCommandResult>): AddConsultantNotesCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch()` */
  static readonly ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatchPath = '/api/ProjectDailyTaskReports/UpdateProjectDailyTaskReportByContractor';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Plain$Response(params?: ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectDailyTaskReportByContractorCommandResult>> {
    return apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Plain(params?: ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectDailyTaskReportByContractorCommandResult> {
    return this.apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectDailyTaskReportByContractorCommandResult>): UpdateProjectDailyTaskReportByContractorCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Response(params?: ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectDailyTaskReportByContractorCommandResult>> {
    return apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch(params?: ApiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Params, context?: HttpContext): Observable<UpdateProjectDailyTaskReportByContractorCommandResult> {
    return this.apiProjectDailyTaskReportsUpdateProjectDailyTaskReportByContractorPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectDailyTaskReportByContractorCommandResult>): UpdateProjectDailyTaskReportByContractorCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete()` */
  static readonly ApiProjectDailyTaskReportsDeleteProjectDailyTaskReportDeletePath = '/api/ProjectDailyTaskReports/DeleteProjectDailyTaskReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain$Response(params?: ApiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectDailyTaskReportCommandResult>> {
    return apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain(params?: ApiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectDailyTaskReportCommandResult> {
    return this.apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectDailyTaskReportCommandResult>): DeleteProjectDailyTaskReportCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Response(params?: ApiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectDailyTaskReportCommandResult>> {
    return apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete(params?: ApiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Params, context?: HttpContext): Observable<DeleteProjectDailyTaskReportCommandResult> {
    return this.apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectDailyTaskReportCommandResult>): DeleteProjectDailyTaskReportCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost()` */
  static readonly ApiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPostPath = '/api/ProjectDailyExpectedTasks/GetProjectDailyExpectedTasks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain$Response(params?: ApiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectDailyExpectedTasksQueryResult>> {
    return apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain(params?: ApiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain$Params, context?: HttpContext): Observable<GetProjectDailyExpectedTasksQueryResult> {
    return this.apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectDailyExpectedTasksQueryResult>): GetProjectDailyExpectedTasksQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Response(params?: ApiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectDailyExpectedTasksQueryResult>> {
    return apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost(params?: ApiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Params, context?: HttpContext): Observable<GetProjectDailyExpectedTasksQueryResult> {
    return this.apiProjectDailyExpectedTasksGetProjectDailyExpectedTasksPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectDailyExpectedTasksQueryResult>): GetProjectDailyExpectedTasksQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyExpectedTasksCreateProjectDailyTaskPost()` */
  static readonly ApiProjectDailyExpectedTasksCreateProjectDailyTaskPostPath = '/api/ProjectDailyExpectedTasks/CreateProjectDailyTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Plain$Response(params?: ApiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectDailyTaskCommandResult>> {
    return apiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Plain(params?: ApiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Plain$Params, context?: HttpContext): Observable<CreateProjectDailyTaskCommandResult> {
    return this.apiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectDailyTaskCommandResult>): CreateProjectDailyTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyExpectedTasksCreateProjectDailyTaskPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Response(params?: ApiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectDailyTaskCommandResult>> {
    return apiProjectDailyExpectedTasksCreateProjectDailyTaskPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksCreateProjectDailyTaskPost(params?: ApiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Params, context?: HttpContext): Observable<CreateProjectDailyTaskCommandResult> {
    return this.apiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectDailyTaskCommandResult>): CreateProjectDailyTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch()` */
  static readonly ApiProjectDailyExpectedTasksUpdateProjectDailyTaskPatchPath = '/api/ProjectDailyExpectedTasks/UpdateProjectDailyTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Plain$Response(params?: ApiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectDailyTaskCommandResult>> {
    return apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Plain(params?: ApiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Plain$Params, context?: HttpContext): Observable<UpdateProjectDailyTaskCommandResult> {
    return this.apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectDailyTaskCommandResult>): UpdateProjectDailyTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Response(params?: ApiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectDailyTaskCommandResult>> {
    return apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch(params?: ApiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Params, context?: HttpContext): Observable<UpdateProjectDailyTaskCommandResult> {
    return this.apiProjectDailyExpectedTasksUpdateProjectDailyTaskPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectDailyTaskCommandResult>): UpdateProjectDailyTaskCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete()` */
  static readonly ApiProjectDailyExpectedTasksDeleteProjectDailyTaskDeletePath = '/api/ProjectDailyExpectedTasks/DeleteProjectDailyTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Plain$Response(params?: ApiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectDailyTaskCommandResult>> {
    return apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Plain(params?: ApiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectDailyTaskCommandResult> {
    return this.apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectDailyTaskCommandResult>): DeleteProjectDailyTaskCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Response(params?: ApiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectDailyTaskCommandResult>> {
    return apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete(params?: ApiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Params, context?: HttpContext): Observable<DeleteProjectDailyTaskCommandResult> {
    return this.apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectDailyTaskCommandResult>): DeleteProjectDailyTaskCommandResult => r.body)
    );
  }

}
